import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import config from '../../../config';
import classNames from 'classnames';

class Index extends Component {
  constructor(props){
    super(props);

    this.state = {
      activeClient: false
    }
  }
  componentDidMount(){
    document.body.classList.remove('light', 'dark', 'white')
    document.body.classList.add('dark');
  }
  _handleHover = (client) => {
    this.setState({
      activeClient: client
    });
  }
  render() {
    const { clients } = this.props;

    return (
      <div className="index transition">
        <div className="index__wrapper">
          <ul className="index__list">
            {clients && clients.map(client =>
              <li className="index__list__item" key={client.id} onMouseOver={() => this._handleHover(client)}>
                <Link to={'/client/' + client.slug}>
                  {client.title.rendered}
                </Link>
              </li>
            )}
          </ul>
          <div className="index__images">
            {clients && clients.map(client => {
              if(client.better_featured_image){
                const image = client.better_featured_image;

                return <div className={classNames('index__image', {
                    'index__image--visible': client.id === this.state.activeClient.id
                  })} key={'i' + client.id}>
                  <img src={image.source_url} alt={image.alt_text} />
                </div>
              }
            })}
          </div>
        </div>
      </div>
    );
  }
}

export default Index;
